import styled from '@emotion/styled';
import Theme from 'App.theme';

export const Card = styled.a`
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  min-height: 18rem;
  margin: 0.5em;
  border: 2px solid ${Theme.greys.GREY1};
  justify-content: space-between;
  overflow: hidden;
  transition: background-color 0.3s;
  text-decoration: none;

  &:hover {
    background-color: ${Theme.greys.GREY0};
  }

  h4 {
    text-align: center;
    color: ${Theme.colours.black};
  }
`;

export const ImageContainer = styled.div`
  background-color: #ffffff;
  border-bottom: 2px solid ${Theme.greys.GREY1};
  width: 100%;
  height: 65%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InfoContainer = styled.div`
  padding: 1rem;
`;
